// Brand colors and theme tokens

export const BRAND = {
  coral: '#FF5A4E',
  coralLight: '#E64438',
  gold: '#FFB627',
  goldLight: '#D89400',
  teal: '#0E5C5C',
  pink: '#EC4899',
};

export const DARK_THEME = {
  isDark: true,
  bg: '#0F0E0D',
  bgElevated: '#1A1917',
  bgCard: '#211F1C',
  border: '#2D2A26',
  borderSubtle: '#23211E',
  text: '#F5F2EC',
  textMuted: '#A19B8F',
  textDim: '#6B665D',
  coral: BRAND.coral,
  gold: BRAND.gold,
  teal: BRAND.teal,
  pink: BRAND.pink,
};

export const LIGHT_THEME = {
  isDark: false,
  bg: '#FAF7F2',
  bgElevated: '#FFFFFF',
  bgCard: '#F2EBDD',
  border: '#E5DECF',
  borderSubtle: '#EFE9DB',
  text: '#1A1612',
  textMuted: '#6B665D',
  textDim: '#A19B8F',
  coral: BRAND.coralLight,
  gold: BRAND.goldLight,
  teal: BRAND.teal,
  pink: BRAND.pink,
};

export const CATEGORIES = [
  { id: 'personal',   name: 'Personlig pleje',         emoji: '🪥' },
  { id: 'work',       name: 'Arbejde',                  emoji: '💼' },
  { id: 'love',       name: 'Kærlighed / parforhold',   emoji: '💕' },
  { id: 'family',     name: 'Familie',                  emoji: '👨‍👩‍👧' },
  { id: 'friends',    name: 'Venner',                   emoji: '👯' },
  { id: 'indoor',     name: 'Indendørs vedligehold',    emoji: '🛋️' },
  { id: 'outdoor',    name: 'Udendørs vedligehold',     emoji: '🌳' },
  { id: 'cleaning',   name: 'Rengøring',                emoji: '🧹' },
  { id: 'school',     name: 'Lektier',                  emoji: '📚' },
  { id: 'daily',      name: 'Daglig vedligehold',       emoji: '🔄' },
  { id: 'birthdays',  name: 'Fødselsdage / mærkedage',  emoji: '🎂' },
];

export const REPEAT_TYPES = [
  { id: 'none',           name: 'Gentages ikke' },
  { id: 'daily',          name: 'Hver dag' },
  { id: 'every_n_days',   name: 'Hver X. dag' },
  { id: 'weekday',        name: 'Hver bestemt ugedag' },
  { id: 'weekly',         name: 'Hver uge' },
  { id: 'every_n_weeks',  name: 'Hver X. uge' },
  { id: 'monthly',        name: 'Hver måned' },
  { id: 'monthly_date',   name: 'Hver måned d. XX' },
  { id: 'yearly',         name: 'Hvert år' },
];

export const WEEKDAYS = [
  { id: 1, name: 'Mandag',  short: 'Man' },
  { id: 2, name: 'Tirsdag', short: 'Tir' },
  { id: 3, name: 'Onsdag',  short: 'Ons' },
  { id: 4, name: 'Torsdag', short: 'Tor' },
  { id: 5, name: 'Fredag',  short: 'Fre' },
  { id: 6, name: 'Lørdag',  short: 'Lør' },
  { id: 0, name: 'Søndag',  short: 'Søn' },
];

export const REWARD_EMOJIS = [
  { emoji: '🍦', label: 'En is' },
  { emoji: '🍕', label: 'Pizza-aften' },
  { emoji: '💆', label: 'Massage' },
  { emoji: '🍷', label: 'Vinaften' },
  { emoji: '🍰', label: 'Kage' },
  { emoji: '☕', label: 'Kaffe på café' },
  { emoji: '🎬', label: 'Filmaften' },
  { emoji: '🥘', label: 'God middag' },
  { emoji: '🛁', label: 'Lang bad' },
  { emoji: '🎁', label: 'En lille gave' },
  { emoji: '😘', label: 'Et stort kys' },
  { emoji: '💕', label: 'Kæreste-tid' },
];
